/**
 * Gold cup used to mark an earned certificate.
 *
 * Drawn rather than an emoji so it looks identical on every platform, and
 * rather than a lucide icon so it can carry the two-tone gold of the artwork.
 */
export function TrophyIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-hidden="true">
      {/* cream wings behind the cup */}
      <path
        d="M13 13c-6 0-11 1.5-11 4.5S8 27 15 28l3-13z"
        fill="#F7EBDF"
      />
      <path
        d="M35 13c6 0 11 1.5 11 4.5S40 27 33 28l-3-13z"
        fill="#F7EBDF"
      />

      {/* cup bowl */}
      <path
        d="M13.5 9h21l-1.2 12.5C32.6 27 28.7 30.5 24 30.5S15.4 27 14.7 21.5z"
        fill="#FBB040"
      />

      {/* rim */}
      <rect x="11" y="4.5" width="26" height="5.5" rx="2.75" fill="#FFD24C" />

      {/* star */}
      <path
        d="M24 12.2l2.5 5.1 5.6.8-4 3.9 1 5.6-5.1-2.7-5.1 2.7 1-5.6-4-3.9 5.6-.8z"
        fill="#FFD24C"
      />

      {/* stem */}
      <rect x="21" y="30" width="6" height="4.5" fill="#E9A22E" />

      {/* foot */}
      <path
        d="M18 39c0-2.8 1.6-4.5 3.4-4.5h5.2c1.8 0 3.4 1.7 3.4 4.5z"
        fill="#FBB040"
      />

      {/* base */}
      <rect x="14" y="38.5" width="20" height="5" fill="#E9A22E" />
    </svg>
  );
}
